export default {
  es: {
    enlaces: {
      contacto: "/contacto",
      tutores: "/servicios/tutores",
      titulados: "/servicios/titulados",
      empresas: "/servicios/empresas",
      colaboradores: "/colaboradores",
      programasyofertas: "/programas-y-ofertas",
      faqs: "/faqs",
      cookies: "/politica-de-cookies",
    },
    portalalumno: "https://portal-demoempleo.dev.doubledot.es/login/",
    portalalumnoregistro:
      "https://portal-demoempleo.dev.doubledot.es/registro",
    portalempresas: "https://portal-demoempleo.dev.doubledot.es/empresas",
    portalempresasregistro:
      "https://portal-demoempleo.dev.doubledot.es/solicitar-cuenta/",
    portaltutores: "https://tutores-demoempleo.dev.doubledot.es/login/",
  },
  en: {},
};



// WEBPACK FOOTER //
// ./src/translations/index.js